import { render, staticRenderFns } from "./processInsManage.vue?vue&type=template&id=08c9a511&"
import script from "./processInsManage.vue?vue&type=script&lang=js&"
export * from "./processInsManage.vue?vue&type=script&lang=js&"
import style0 from "./processInsManage.vue?vue&type=style&index=0&id=08c9a511&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports